import types from '../mutation-types';
import AccountUserApi from '../../api/accountUser';

const IS_RESTRICTED_STORAGE_KEY = 'restricted_admin_key';
const state = {
  config: JSON.parse(localStorage.getItem(IS_RESTRICTED_STORAGE_KEY)) || {
    restricted_admin: 'not_restricted',
  },
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

const mutations = {
  SET_CONFIG(_state, config) {
    _state.config = config;
    localStorage.setItem(IS_RESTRICTED_STORAGE_KEY, JSON.stringify(config));
  },
  SET_FETCHING(_state, status) {
    _state.uiFlags.isFetching = status;
  },
};

const actions = {
  async fetch({ commit }) {
    commit(types.SET_FETCHING, true);
    try {
      const response = await AccountUserApi.fetch();
      commit(types.SET_CONFIG, response.data);
    } catch (error) {
      throw new Error('Failed to fetch account user: ' + error.message);
    } finally {
      commit(types.SET_FETCHING, false);
    }
  },
};

const getters = {
  isRestricted: _state => {
    return _state.config?.restricted_admin === 'restricted';
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
